// components/export/exportToWord.js
import { Document, Packer, Paragraph, Table, TableRow, TableCell } from "docx";
import { saveAs } from "file-saver";

export const exportToWord = async (studentRecords, fileName) => {
  const sections = studentRecords.map(student => {
    if (!student || !student.scholastic) return null;

    return {
      properties: {},
      children: [
        new Paragraph(`Unit Test Report (Class ${student.class})`),
        new Paragraph(`Name: ${student.name}`),
        new Paragraph(`Student ID: ${student.student_id}`),
        new Paragraph(`Class: ${student.class}`),
        new Table({
          rows: [
            new TableRow({
              children: ["Subjects", "Assessment Spec", "Max Marks", "Scored", "Total", "Grade"].map(cell => new TableCell({ children: [new Paragraph(cell)] }))
            }),
            ...Object.entries(student.scholastic).flatMap(([subject, assessments]) =>
              Object.entries(assessments).map(([spec, data]) =>
                new TableRow({
                  children: [
                    new TableCell({ children: [new Paragraph(subject)] }),
                    new TableCell({ children: [new Paragraph(spec)] }),
                    new TableCell({ children: [new Paragraph((data?.max_marks || 0).toString())] }),
                    new TableCell({ children: [new Paragraph((data?.scored || 0).toString())] }),
                    new TableCell({ children: [new Paragraph((data?.total || 0).toString())] }),
                    new TableCell({ children: [new Paragraph(data?.grade || "N/A")] }),
                  ],
                })
              )
            )
          ]
        }),
        new Table({
          rows: [
            new TableRow({
              children: ["Observation", "Grade"].map(cell => new TableCell({ children: [new Paragraph(cell)] }))
            }),
            ...Object.entries(student.observation || {}).map(([obs, grade]) =>
              new TableRow({
                children: [
                  new TableCell({ children: [new Paragraph(obs)] }),
                  new TableCell({ children: [new Paragraph(grade)] }),
                ]
              })
            )
          ]
        }),
        new Table({
          rows: [
            new TableRow({
              children: ["Co-Scholastic", "Marks Scored"].map(cell => new TableCell({ children: [new Paragraph(cell)] }))
            }),
            ...Object.entries(student.co_scholastic || {}).map(([subject, marks]) =>
              new TableRow({
                children: [
                  new TableCell({ children: [new Paragraph(subject)] }),
                  new TableCell({ children: [new Paragraph(marks.toString())] }),
                ]
              })
            )
          ]
        }),
        new Paragraph(`Remarks: ${student.remarks || ""}`)
      ]
    };
  }).filter(Boolean);

  const doc = new Document({ sections });
  const blob = await Packer.toBlob(doc);
  saveAs(blob, `${fileName}.docx`);
};
